import React from 'react'

import { Stack, ITag } from 'office-ui-fabric-react'

import { ShownTagInput } from './ShownTagInput'
import { uniq } from 'lodash'

export const DEVICE_PREFIX = 'Device/'
export const devices = ['Desktop', 'Tablet', 'Mobile', 'SmartTV']

// Pull the selected device keys (e.g. 'Desktop') out of the generic
// targetingRules list (e.g. 'Device/Desktop'), ignoring any non-device rules.
export function getSelectedDevices(targetingRules: string[]): string[] {
  return targetingRules
    .filter((r) => r.indexOf(DEVICE_PREFIX) === 0)
    .map((r) => r.replace(DEVICE_PREFIX, ''))
    .sort()
}

// Replace the device rules in targetingRules with the given selection,
// preserving any rules that are not device rules.
export function applyDeviceSelection(
  targetingRules: string[],
  selectedKeys: string[]
): string[] {
  return uniq([
    ...targetingRules.filter((r) => r.indexOf(DEVICE_PREFIX) !== 0),
    ...selectedKeys.map((key) => `${DEVICE_PREFIX}${key}`),
  ])
}

// Bridge between the generic 'Device/<Name>' targeting rules and the lowercase
// device list (e.g. 'desktop') that the r2b2 replacement integration config uses.
export function devicesToTargetingRules(deviceList: string[]): string[] {
  return deviceList.map(
    (d) => `${DEVICE_PREFIX}${d.charAt(0).toUpperCase()}${d.slice(1)}`
  )
}

export function targetingRulesToDevices(targetingRules: string[]): string[] {
  return getSelectedDevices(targetingRules).map((d) => d.toLowerCase())
}

interface InputProps {
  targetingRules: string[]
  disabled: boolean
  onChange: (targetingRules: string[]) => any
  label?: string
  gap?: number
  deviceKeys?: string[]
}

export const DeviceTargetingForm: React.FC<InputProps> = (props) => {
  const {
    targetingRules,
    disabled,
    onChange,
    label = 'Target by Device',
    gap = 0,
    deviceKeys = devices,
  } = props
  return (
    <Stack gap={gap}>
      <ShownTagInput
        label={label}
        selectedKeys={getSelectedDevices(targetingRules)}
        onChange={(value?: ITag[]) => {
          if (!value) {
            return
          }
          onChange(
            applyDeviceSelection(
              targetingRules,
              value.map((v) => v.key as string)
            )
          )
        }}
        disabled={disabled}
        options={deviceKeys.map((key) => ({ key, name: key }))}
      />
    </Stack>
  )
}
